import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import getAPIbaseURL from "../../utils/helpers";
import i18n from "../../i18n";

const API_URL = `${getAPIbaseURL()}/workItems`;

// Create a work item
export const createWorkItem = createAsyncThunk(
  "workItems/createWorkItem",
  async (workItemData, thunkAPI) => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.post(`${API_URL}/`, workItemData, {
        headers: { Authorization: `Bearer ${token}` },
      });
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || i18n.t("slices.workItemsSlice.createWorkItemError"));
    }
  }
);

// Fetch all work items
export const fetchWorkItems = createAsyncThunk(
  "workItems/fetchWorkItems",
  async (_, thunkAPI) => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(`${API_URL}/`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || i18n.t("slices.workItemsSlice.fetchWorkItemsError"));
    }
  }
);

// Update a work item
export const updateWorkItem = createAsyncThunk(
  "workItems/updateWorkItem",
  async ({ workItemId, updates }, thunkAPI) => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.put(`${API_URL}/${workItemId}`, updates, {
        headers: { Authorization: `Bearer ${token}` },
      });
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || i18n.t("slices.workItemsSlice.updateWorkItemError"));
    }
  }
);

// Delete a work item
export const deleteWorkItem = createAsyncThunk(
  "workItems/deleteWorkItem",
  async (workItemId, thunkAPI) => {
    try {
      const token = localStorage.getItem("token");
      await axios.delete(`${API_URL}/${workItemId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      return workItemId;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || i18n.t("slices.workItemsSlice.deleteWorkItemError"));
    }
  }
);

const workItemsSlice = createSlice({
  name: "workItems",
  initialState: {
    items: [],
    isLoading: false,
    error: null,
    message: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(createWorkItem.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(createWorkItem.fulfilled, (state, action) => {
        state.isLoading = false;
        state.items.push(action.payload);
        state.message = i18n.t("slices.workItemsSlice.workItemCreatedSuccess");
      })
      .addCase(createWorkItem.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(fetchWorkItems.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchWorkItems.fulfilled, (state, action) => {
        state.isLoading = false;
        state.items = action.payload;
      })
      .addCase(fetchWorkItems.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(updateWorkItem.fulfilled, (state, action) => {
        const updatedWorkItem = action.payload;
        const index = state.items.findIndex((w) => w.id === updatedWorkItem.id);
        if (index !== -1) {
          state.items[index] = updatedWorkItem;
        }
        state.message = i18n.t("slices.workItemsSlice.workItemUpdatedSuccess");
      })
      .addCase(deleteWorkItem.fulfilled, (state, action) => {
        state.items = state.items.filter((w) => w.id !== action.payload);
        state.message = i18n.t("slices.workItemsSlice.workItemDeletedSuccess");
      });
  },
});

export default workItemsSlice.reducer;